import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./i18n.config";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Api from "@utils/api";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@hooks/queryClient";

const runApp = async () => {
  Api.init();

  ReactDOM.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
    document.getElementById("root")
  );
};

runApp();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
